export const vdataTable = {
  footerProps: {
    "items-per-page-options": [5, 10, 15, { text: "All", value: -1 }]
  }
};
